import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint, SignInPageProps } from '@backstage/plugin-app-react';
import { SignInPage, SignInProviderConfig } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

/**
 * Sign-in page extension.
 *
 * On localhost the guest provider is prepended so developers can skip OAuth.
 * In all other environments only the AzureAD (Microsoft) provider is shown.
 *
 * The component is built inside the loader so the `window.location` read
 * happens at runtime (after the browser has settled on its origin), not at
 * module-evaluation time.
 */
const signInPageExtension = SignInPageBlueprint.make({
    params: {
        loader: async () => {
            const host = window.location.host;
            const providers: ('custom' | SignInProviderConfig | 'guest')[] = [];

            if (host.includes('localhost')) {
                providers.push('guest');
            }

            providers.push({
                id: 'microsoft-auth-provider',
                title: 'AzureAD',
                message: 'Sign in using Azure AD',
                apiRef: microsoftAuthApiRef,
            });

            return (props: SignInPageProps) => (
                <SignInPage {...props} auto providers={providers} />
            );
        },
    },
});

/**
 * Frontend module that registers the custom sign-in page as a native New
 * Frontend System extension, replacing the `components.SignInPage` previously
 * passed to `convertLegacyAppOptions`.
 */
export const signInModule = createFrontendModule({
    pluginId: 'app',
    extensions: [signInPageExtension],
});


